const usAccountTransactionTypeOptions: { [key: string]: string } = {
  Reversal: 'Reversal',
  'Credit Card': 'Credit Card',
  Refund: 'Refund',
  'ACH Funding': 'ACH Funding',
  'ACH Withdrawal': 'ACH Withdrawal',
  'RTP Withdrawal': 'RTP Withdrawal',
  'OCT': 'OCT',
  'Fedwire Funding': 'Fedwire Funding',
  'Fedwire Withdrawal': 'Fedwire Withdrawal',
};

export default usAccountTransactionTypeOptions;
